import home from '@/pages/views/home/home.vue'
import company from '@/pages/views/companyInfos/company.vue'
import newsInfo from '@/pages/views/news/newsInfo.vue'
import news from '@/pages/views/news/news.vue'
import product from '@/pages/views/product/product.vue'
import join from '@/pages/views/joinus/join.vue'
import jobInfo from '@/pages/views/joinus/jobInfo.vue'
import bidding from '@/pages/views/bidding/bidding.vue'
import biddingInfo from '@/pages/views/bidding/biddingInfo.vue'
import privacy from '@/pages/views/privacy/privacy.vue'

/* eslint-disable */
const frontViews = [{
    path: '/index',
    name: 'home',
    component: home,
    meta: {
      title: '国家农机装备创新中心'
    },
  },
  {
    path: '/company',
    name: 'company',
    component: company,
    meta: {
      title: '国家农机装备创新中心'
    },
  },
  {
    path: '/newsInfo/:newsId',
    name: 'newsInfo',
    component: newsInfo,
    meta: {
      title: '国家农机装备创新中心'
    },
  },
  {
    path: '/news',
    name: 'news',
    component: news,
    meta: {
      title: '国家农机装备创新中心'
    },

  },
  {
    path: '/product',
    name: 'product',
    component: product,
    meta: {
      title: '国家农机装备创新中心'
    },
  },
  {
    path: '/join',
    name: 'join',
    component: join,
    meta: {
      title: '国家农机装备创新中心'
    },
  },
  {
    path: '/jobInfo/:jobId',
    name: 'jobInfo',
    component: jobInfo,
    meta: {
      title: '国家农机装备创新中心'
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy,
    meta: {
      title: '国家农机装备创新中心'
    },

  },
  {
    path: '/bidding',
    name: 'bidding',
    component: bidding,
    meta: {
      title: '国家农机装备创新中心'
    },
  },
  {
    path: '/biddingInfo/:bidId',
    name: 'biddingInfo',
    component: biddingInfo,
    meta: {
      title: '国家农机装备创新中心'
    },
  }

];
export default [...frontViews]



// WEBPACK FOOTER //
// ./src/router/views.js